import { Component, OnInit, inject } from '@angular/core';
import { Location, NgIf } from '@angular/common';
import {HeaderTextService} from '../../services/header-text.service';
import {MatMenuModule} from '@angular/material/menu';
import {UserWebservice} from 'src/app/services/webservices/user.webservice';
import {YoungWebservice} from 'src/app/services/webservices/young.webservice';
import {environment} from '../../../environments/environment';
import {Destroyed} from '../../utils/directives/destroyed.directive';
import {takeUntil} from 'rxjs/operators';
import {Season} from '../../utils/helper/season.model';
import {SimpleYoungDto} from '../../model/dto/simple-young.dto';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MsalService} from "@azure/msal-angular";
import {LocalStorageService} from "../../services/localstorage.service";
import { MatDialog } from '@angular/material/dialog';
import {
  DialogModificationProfileComponent
} from "../../utils/dialog/dialog-modification-profile/dialog-modification-profile.component";
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    imports: [MatToolbarModule, MatIconModule, MatMenuModule, NgIf]
})
export class ToolbarComponent extends Destroyed implements OnInit {
    private readonly headerTextService = inject(HeaderTextService);
    private readonly location = inject(Location);
    private readonly userService = inject(UserWebservice);
    private readonly youngWebService = inject(YoungWebservice);
    private readonly msalService = inject(MsalService);
    private readonly localStorageService = inject(LocalStorageService);
    private readonly dialog = inject(MatDialog);


    public title = '';
    showBackButton = false;
    showPartnerBtn = false;
    showLogoutBtn = false;

    public dateBuild = '';
    private pageAllowPartnerBtn: boolean;
    private isUserMineurAndJobValid: boolean;

    private readonly season = new Season();

    constructor() {
        super();
        this.dateBuild = environment.timestamp === '#{timestamp}' ? 'Dev' : environment.timestamp;
    }

    ngOnInit() {
      this.headerTextService.title.pipe(takeUntil(this.destroyed)).subscribe(title => {
          this.title = title;
      });

      this.headerTextService.backButton.pipe(takeUntil(this.destroyed)).subscribe(val => {
          this.showBackButton = val;
      });

      this.headerTextService.showLogoutBtn.pipe(takeUntil(this.destroyed)).subscribe(val => {
          this.showLogoutBtn = val;
      });


      this.headerTextService.showPartnerBtn.pipe(takeUntil(this.destroyed)).subscribe(val => {
            this.pageAllowPartnerBtn = val;
            if (val) {
              this.testIfIsChildOrNot();
            }
            this.setShowPartnerBtn();
        });
    }

    testIfIsChildOrNot() {
      this.userService.getUserIsChild().pipe(takeUntil(this.destroyed)).subscribe((response: boolean) => {
        if (response) {
          this.youngWebService.getYoung(Number(this.localStorageService.getItem('youngId')))
            .pipe(takeUntil(this.destroyed))
            .subscribe((young: SimpleYoungDto) => {
              const year = young.user?.listOfYears?.find(y => new Date(y.dateStart).getFullYear() === this.season.dateStart.getFullYear()
                && new Date(y.dateEnd).getFullYear() === this.season.dateEnd.getFullYear());
              if (year !== null && year !== undefined) {
                this.isUserMineurAndJobValid = year.isValidatedJob;
                this.setShowPartnerBtn();
              }
            });
        } else {
          this.isUserMineurAndJobValid = false;
        }
      });
    }

    goBack() {
        this.location.back();
    }

  logout() {
    this.msalService.logoutRedirect();
  }

  openModificationProfilePopup() {
    this.dialog.open(DialogModificationProfileComponent);
  }

  private setShowPartnerBtn(): void {
      this.showPartnerBtn = this.pageAllowPartnerBtn && this.isUserMineurAndJobValid;
  }
}
